import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { IronClub } from '../../api/models';

export type TABLE_TYPE = Table<IronClub>;

export const TABLE = 'ironClub';
const SCHEMA = 'ironClubId, sortId';

class IronClubDatabase implements DataRepository<IronClub> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<IronClub | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: IronClub, key: Key): Promise<IronClub> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: IronClub[]): Promise<IronClub[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<IronClub[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const IronClubDB = new IronClubDatabase(db);
